import { createSelector } from 'reselect'

const selectAuth = state => state.auth
const selectQueue = state => state.queue

export const selectAuthUser = createSelector(selectAuth, auth => auth.user || {})
export const selectIsAuthenticated = createSelector(selectAuthUser, user => !_.isEmpty(user))

export const selectIsMasquerade = createSelector(selectAuthUser, user => user.is_masquerade)

export const selectAuthUsername = createSelector(selectAuthUser, user => user.name)

export const selectAuthSSO = createSelector(selectAuth, auth => auth.sso)

export const selectUserType = createSelector(selectAuthUser, user => {
  if (user.is_settlement_broker === true) {
    return 'settlement-broker'
  }

  if (user.is_settlement_broker === false) {
    return 'settlement-officer'
  }

  if (user.is_loan_broker === true) {
    return 'loan-broker'
  }

  if (user.is_loan_officer === true) {
    return 'loan-officer'
  }
})

export const selectUserCompany = createSelector(selectAuthUser, user => {
  if (user.settlement_broker_name) {
    return user.settlement_broker_name
  }

  if (user.loan_broker_name) {
    return user.loan_broker_name
  }

  if (user.broker_name) {
    return user.broker_name
  }
})

export const selectFeatureFlags = createSelector(selectAuthUser, user => user.feature_flags || {})

// this will be removed with PARTNER-863 https://opcity.atlassian.net/browse/PARTNER-863
export const selectBrokerCollectionsTempFF = createSelector(selectFeatureFlags, feature_flags => feature_flags['broker_collections_temp_ff'] || false)

export const selectBrokerCollectionsInReviewTempFF = createSelector(
  selectFeatureFlags,
  feature_flags => feature_flags['broker_collections_in_review_temp_ff'] || false
)

export const selectAgentTerminationEnabled = createSelector(
  selectFeatureFlags,
  feature_flags => feature_flags['agent_termination_enabled_at'] || false
)

export const selectAuthUserFeatures = createSelector(selectAuthUser, user => user.features || {})
export const selectFeaturesInitialized = createSelector(selectAuthUserFeatures, features => features.initialized)
export const selectFeaturesBootstrap = createSelector(selectAuthUserFeatures, features => features.bootstrap)
export const selectFeaturesClientSideId = createSelector(selectAuthUserFeatures, features => features.client_side_id)
export const selectFeaturesSecureModeHash = createSelector(selectAuthUserFeatures, features => features.secure_mode_hash)
export const selectFeaturesUserProfile = createSelector(selectAuthUserFeatures, features => features.user_profile)

export const selectIsBogota = createSelector(
  selectFeatureFlags,
  (feature_flags) => {
    return (!!feature_flags.is_bogota || !!feature_flags.is_bogota_manager || !!feature_flags.is_bogota_quality)
  }
)

export const selectShowBogotaLeaderboard = createSelector(
  [selectIsBogota, selectQueue],
  (is_bogota, queue) => {
    return (queue && queue.showBogotaLeaderboard) || is_bogota
  }
)
